// @ts-nocheck



import React from 'react';



import { contractorApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
import { convertContractorToString } from '../../lib/helpers';





export default (selectProps) =>
<AutocompleteSelect
  placeholder="Выберите подрядчика"
  fetch={async (params) => {
    return await contractorApi.fetchContractors({
      ...selectProps.filter,
      ...params
    });
  }}
  fetchSingle={contractorApi.fetchContractor}
  notFoundText="Подрядчики не найдены"
  renderOption={(contractor, Option) =>
  <Option key={contractor.id} value={contractor.id}>
        {convertContractorToString(contractor)}
      </Option>
  }
  {...selectProps} />;
